import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const pressApiService = createApi({
  reducerPath: "pressApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getPress: builder.query({
      query: (args) => {
        let query = queryParams(args);
        if (args?.id) {
          return `press/get/${args?.id}${query}`;
        }

        return `press/get${query}`;
      },
      keepUnusedDataFor: 0,
    }),
  }),
});

export const { useGetPressQuery } = pressApiService;
